import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ChildDeactivationState } from './child-deactivation.state';

export const selectChildDeactivationState = createFeatureSelector<ChildDeactivationState>('childDeactivation');

export const selectChildDeactivationRequests = createSelector(
  selectChildDeactivationState,
  (state) => state.requests
);

export const selectResolvedChildDeactivationRequests = createSelector(
  selectChildDeactivationState,
  (state) => state.resolvedRequests
);

export const selectChildDeactivationLoading = createSelector(
  selectChildDeactivationState,
  (state) => state.loading
);

export const selectChildDeactivationError = createSelector(
  selectChildDeactivationState,
  (state) => state.error
);

export const selectChildDeactivationActionInProgressId = createSelector(
  selectChildDeactivationState,
  (state) => state.actionInProgressId
);
